import React from 'react';
import Modal from '../../../../../component/modal/Modal';
import Button from '../../../../../component/ui/Button';

export default function SaleAccountAlertWarningModal({
	isOpenModal,
	setIsOpenModal,
	cancelAccountSelect,
	selectedAccount = '',
	recommendedAccount = 'Sales',
}) {
	return (
		<Modal
			className={'confirmatinBoxModal'}
			title="Confirm Sales Account Selection"
			isOpen={isOpenModal}
			onClose={() => {
				setIsOpenModal(false);
			}}
			cancelButton={() => {
				setIsOpenModal(false);
			}}
		>
			<div
				style={{
					backgroundColor: '#E6F5FF',
					padding: '16px 20px',
					marginBottom: '16px',
					borderRadius: '6px',
					fontWeight: '500',
					color: '#222',
					fontSize: '14px',
					lineHeight: '1.5',
				}}
			>
				You have selected an account that is not an Income account. Sales invoices are usually
				recorded under a Sales or Income account. Selecting this account may affect your accounting
				reports.
			</div>

			<div
				style={{
					marginBottom: '20px',
					fontSize: '14px',
					lineHeight: '1.8',
					color: '#333',
				}}
			>
				<div>
					<strong>Selected Account:</strong> {selectedAccount || '—'}
				</div>
				<div>
					<strong>Recommended Account:</strong> {recommendedAccount || 'Sales'}
				</div>
			</div>

			<div className="d-flex justify-content-end align-items-center gap-4">
				<Button
					type="button"
					button={'Cancel'}
					className="mt-0 px-4 btn-secondary relative"
					onClick={() => cancelAccountSelect()}
				/>
				<Button
					type="button"
					button={'Confirm'}
					className="mt-0 px-5 btn-primary relative"
					onClick={() => {
						setIsOpenModal(false);
					}}
				/>
			</div>
		</Modal>
	);
}
